<template>
  <div>
    <!-- 上方搜索框 -->
    <div class="search-top-row">
      <!--冰柜丢失报废页面搜索 -->
      <!-- 第一排 -->
      <el-row :gutter="20">
        <el-col :span="6" >
          <el-input
            class="item-input"
            v-model="queryParams.pocName"
            size="small"
            placeholder="请输入门店名称"
          ></el-input>
        </el-col>

        <el-col :span="6">
          <el-input
            class="item-input"
            v-model="queryParams.wholesalerName"
            size="small"
            placeholder="请输入经销商名称"
          ></el-input>
        </el-col>

        <el-col :span="6" >
          <el-input
            class="item-input"
            v-model="queryParams.coolerAssetCode"
            size="small"
            placeholder="请输入资产编码"
          ></el-input>
        </el-col>
  
        <el-col :span="6" >
          <el-input
            class="item-input"
            v-model="queryParams.abiPocId"
            size="small"
            placeholder="请输入POCID"
          ></el-input>
        </el-col>
      </el-row>
      <!-- 第二排 -->
      <el-row  :gutter="20">
        <el-col :span="6" >
          <el-input
            class="item-input"
            v-model="queryParams.wccsid"
            size="small"
            placeholder="请输入WCCSID"
          ></el-input>
        </el-col>

        <el-col :span="6" >
          <el-input
            class="item-input"
            v-model="queryParams.coolerItemNo"
            size="small"
            placeholder="请输入冰柜型号"
          ></el-input>
        </el-col>

        <el-col :span="6" >
           <el-select size="small" v-model="queryParams.execTypeList" style="width:270px" clearable placeholder="请选择冰柜状态">
              <el-option  v-for="item in scrapFreezerStatus" :key="item.key" :label="item.key" :value="item.value">
              </el-option>
            </el-select>
        </el-col>

        <el-col :span="6" >
           <el-select size="small" style="width:270px" v-model="queryParams.coolerLabel" clearable placeholder="请选择冰柜追踪状态">
              <template v-if="queryParams.execTypeList==='01,03,12,91,92'">
              <el-option  v-for="item in freezerLabel" :key="item.value" :label="item.label" :value="item.value" >
              </el-option>
               </template>
            </el-select>
        </el-col>
      </el-row>
      <!-- 第三排 -->
      <el-row :gutter="20">
         <el-col :span="6" class="item-input" >
         <el-select
            style="width: 100%"
            v-model="queryParams.year"
            size="small"
            placeholder="请选择年份"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in yearList"
              :key="idx"
              :value="item.name"
              :label="item.name"
            />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select
            style="width: 100%"
            v-model="queryParams.month"
            size="small"
            placeholder="请选择月份"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in monthList"
              :key="idx"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </el-col>

        <el-col :span="8">
          <el-row :gutter="20">
            <el-col :span="6">
              <div @click="search" class="normal common">搜索</div>
            </el-col>
            <el-col :span="4">
              <div @click="reset" class="normal common">重置</div>
            </el-col>
          </el-row>
        </el-col>

      <el-col :span="4" :gutter="20">
        <el-row v-if="type!=='all'">
          <el-col :span="9">
          <div
            @click="registerScrapCooler"
            class="common"
            :class="registerButton?'disable':'normal'"
          >登记报废</div>
        </el-col>

        <el-col :span="10">
          <div
            @click="registerLostCooler"
            :class="registerButton?'disable':'normal'"
            class="common"
            style="margin-left:25px"
          >登记丢失</div>
        </el-col>
        </el-row>
        <!--全部导出 -->
        <div v-else
           style=" margin-left:90px;"
            @click="exportDetail"
            class="common normal"
          >导出明细</div>
      </el-col>
        
      </el-row>
      
    <!-- 查看冰柜信息 -->
      <el-row v-if="type == 'approve'">
        <el-col :span="5">
          <el-input
            class="item-input"
            v-model="queryParams.pocName"
            size="small"
            placeholder="请输入门店名称"
          ></el-input>
        </el-col>

        <el-col :span="5" >
          <el-input
            class="item-input"
            v-model="queryParams.wholesalerName"
            size="small"
            placeholder="请输入经销商名称"
          ></el-input>
        </el-col>

        <el-col :span="5" >
          <el-input
            class="item-input"
            v-model="queryParams.coolerAssetCode"
            size="small"
            placeholder="请输入资产编码"
          ></el-input>
        </el-col>

        <el-col :span="5" >
          <el-input
            class="item-input"
            v-model="queryParams.abiPocId"
            size="small"
            placeholder="请输入POCID"
          ></el-input>
        </el-col>

        <el-col :span="5">
          <el-input
            class="item-input"
            v-model="queryParams.coolerItemNo"
            size="small"
            placeholder="冰柜型号"
          ></el-input>
        </el-col>

        <el-col :span="5" >
          <div @click="search" class="normal common">搜索</div>
        </el-col>
      </el-row>
      <el-row v-if="type == 'lost' || type == 'scrap'">
        <el-col :span="5">
          <el-input
            class="item-input"
            v-model="queryParams.pocName"
            size="small"
            placeholder="门店名称"
          ></el-input>
        </el-col>

        <el-col :span="5" :offset="1">
          <el-input
            class="item-input"
            v-model="queryParams.wholesalerName"
            size="small"
            placeholder="经销商名称"
          ></el-input>
        </el-col>

        <el-col :span="5" :offset="1">
          <el-input
            class="item-input"
            v-model="queryParams.coolerAssetCode"
            size="small"
            placeholder="资产编码"
          ></el-input>
        </el-col>

        <el-col :span="5" class="item-input" :offset="1">
          <div>
            <el-date-picker
              style="width: 100%"
              size="small"
              v-model="queryParams.lostYear"
              type="year"
              placeholder="年份"
              format="yyyy"
              value-format="yyyy"
            ></el-date-picker>
          </div>
        </el-col>

        <el-col :span="5">
          <el-select
            style="width: 100%"
            v-model="queryParams.lostMonth"
            size="small"
            placeholder="月份"
            clearable
            filterable
          >
            <el-option
              v-for="(item, idx) in monthList"
              :key="idx"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </el-col>

        <el-col :span="5" :offset="1">
          <el-input
            class="item-input"
            v-model="queryParams.coolerItemNo"
            size="small"
            placeholder="冰柜型号"
          ></el-input>
        </el-col>

        <el-col :span="5" :offset="1">
          <div @click="search" class="normal common">搜索</div>
        </el-col>
      </el-row>
    </div>

    <!-- 冰柜列表 -->
    <div class="trade-order-list" >
      <div
        class="trade-order-item"
        v-for="item in orderList"
        :key="item.coolerAsset.coolerAssetCode"
      >
        <order-list-item ref="orderItem" :info="item" :type="type" @infoCheck="infoCheck"></order-list-item>
      </div>
      <div class="no-data" v-if="orderList.length === 0">暂无数据</div>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        v-if="orderList.length !== 0"
        background
        :total="total"
        layout="total, prev, pager, next"
        :current-page="queryParams.page"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 登记提示弹框 -->
    <el-dialog title="提示" :visible.sync="showDialog" width="35%">
      <div class="dialog-data">
        <div style="margin-bottom:20px;">
          <!-- <img src="@/assets/images/no-conformity.png" class="sucess-icon" /> -->
          <i style="color:#e6a23c;font-size:35px;" class="el-icon-warning"></i>
          <span class="dialog-text" v-if="registerType == 'lost' ">是否确认提交丢失信息</span>
          <p style="color:#c8102d" v-if="registerType == 'lost' ">*登记丢失后会影响区域资产冰柜追踪率，请谨慎操作</p>
          <span class="dialog-text" v-if="registerType == 'scrap' ">是否确认提交报废信息</span>
          <p  style="color:#c8102d" v-if="registerType == 'scrap' ">*登记报废后会影响区域资产冰柜追踪率，请谨慎操作</p>
        </div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="填写丢失说明..."
          v-model="applyReason"
          style="width:60%"
          v-if="registerType == 'lost' "
        ></el-input>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="填写报废说明..."
          v-model="applyReason"
          style="width:60%"
          v-if="registerType == 'scrap' "
        ></el-input>
      </div>
      <span slot="footer" class>
        <el-button type="danger" plain @click="showDialog = false">取 消</el-button>
        <el-button type="danger" @click="confirmRegister">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 登记成功弹框 -->
    <el-dialog title="提示" :visible.sync="registerSucess" width="30%">
      <div class="center-flex">
        <div>
          <div class="dialog-text">
            <img src="@/assets/images/complete.png" class="sucess-icon" /><span>登记成功</span>
          </div>
        </div>
        <el-button type="danger" @click="registerSucess = false" style="margin-top:40px;">确 定</el-button>
      </div>
    </el-dialog>

    <!-- excel文件 -->
    <Vform ref="form" :params="params" :url="targetUri"></Vform>
  </div>
</template>

<script>
import orderListItem from "./cooler-list-item";
import orderApi from "@/api/order";
import { commonUtils } from '@/utils/common'
import{tokenUtils}from '@/utils/auth'
import baseApi from "@/api/base"
import Vform from "@/components/v-form"
import {localStorageUtils} from '@/utils/localstorage'
export default {
  name: "cooler-list",
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  components: {
    orderListItem,
    Vform
  },
  created () {
    this.freezerStatus()
  },
  data() {
    return {
      scrapFreezerStatus:[],//冰柜状态
       freezerLabel: [{value:'1', label:'正常'},
                      {value:'5',label:'未插电'},
                      {value:'6',label:'位移报警'}],//冰柜标签
       //冰柜标签
      monthList: [
        { id: "1", name: "1月" },
        { id: "2", name: "2月" },
        { id: "3", name: "3月" },
        { id: "4", name: "4月" },
        { id: "5", name: "5月" },
        { id: "6", name: "6月" },
        { id: "7", name: "7月" },
        { id: "8", name: "8月" },
        { id: "9", name: "9月" },
        { id: "10", name: "10月" },
        { id: "11", name: "11月" },
        { id: "12", name: "12月" }
      ], //月份下拉值
      yearList:[
      {id:1,name:'2019'},
      {id:2,name:'2020'},
      {id:3,name:'2021'},
      {id:4,name:'2022'},
      ],//年份下拉值
      queryParams: {
        page: 1,
        pageSize: 4,
        pocName: "",
        abiPocId: "",
        wholesalerName: "",
        coolerAssetCode: "",
        coolerItemNo: "",
        year: "",//年份
        month: "",//月份
        execType: "",
        waitApprove: "",
        wccsid:'',//wccsid
        execTypeList :'',//冰柜状态
        coolerLabel:''//冰柜标签
      }, //搜索查询参数
      registerButton: true,
      checkedList: [], //选中的需要登记丢失的冰柜
      showDialog: false, //是否显示弹框
      registerSucess: false, //登记成功弹框
      orderList: [], //冰柜列表
      total: 0, //列表总数
      applyReason: "", //登记说明
      registerType: "", //登记类型  丢失或者报废
       targetUri:'',//下载地址
       params:{}//下载参数
    };
   
  },
  watch: {
    type: {
      handler() {
        //清空搜索参数
        if(this.$route.path==='/trade/cooler/store'){
          localStorageUtils.remove('queryParamsall')
        }
         if(this.$route.path==='/trade/cooler/all'){
          localStorageUtils.remove('queryParamsstore')
        }
        this.queryParams.page = 1;
        this.queryParams.pocName = '';
        this.queryParams.abiPocId = "";
        this.queryParams.wholesalerName = "";
        this.queryParams.coolerAssetCode = "";
        this.queryParams.coolerItemNo = "";
        this.queryParams.year = "";
        this.queryParams.month = "";
        this.queryParams.wccsid=''
        this.queryParams.coolerLabel=''
        this.queryParams.execTypeList=''
        this.registerButton = true;
        this.freezerStatus()
        this.queryCoolerList();
      },
      immediate: true
    }
  },
  methods: {
   async freezerStatus(){
    this.queryParams= JSON.parse(localStorageUtils.get(`queryParams${this.type}`))||this.queryParams
   const {data:{resultData}}=await baseApi.getDictData({name:'coolerStatusParamMap'})
      if(this.type==='store'){
      this.scrapFreezerStatus=[{key:'正常投放',value:'01,03,12,91,92'},{key:'在库中',value:'02,93'}]
      }else{
         this.scrapFreezerStatus=resultData.coolerStatusParamMap
       }
    },
    // 明细导出
    exportDetail(){
        const token = tokenUtils.getToken(true)
        this.params=commonUtils.deepClone(this.queryParams)
        this.targetUri = commonUtils.getApiUrl('/trade-apply/cooler-track/export')
        this.params.token=token
        if(!this.params.execTypeList){
         this.params.execTypeList='01,03,12,91,92,02,93,04,05,21,22,23'
        }
        this.$refs.form.submit()
    },
    // 重置
    reset(){
      this.queryParams={
        page: 1,
        pageSize: 4,
        pocName: "",
        abiPocId: "",
        wholesalerName: "",
        coolerAssetCode: "",
        coolerItemNo: "",
        year: "",//年份
        month: "",//月份
        execType: "",
        waitApprove: "",
        wccsid:'',//wccsid
        execTypeList :'',//冰柜状态
        coolerLabel:''//冰柜标签
      }
      this.queryCoolerList()
    },
    //查询冰柜列表
    async queryCoolerList() {
      let params = {
        pocName: this.queryParams.pocName,
        abiPocId: this.queryParams.abiPocId,
        wholesalerName: this.queryParams.wholesalerName,
        coolerAssetCode: this.queryParams.coolerAssetCode,
        coolerItemNo: this.queryParams.coolerItemNo,
        page: this.queryParams.page,
        pageSize:this.queryParams.pageSize,
        // execType: this.queryParams.execType,
        // execTypeList:this.queryParams.execTypeList,
        year:this.queryParams.year,
        month:this.queryParams.month,
        wccsid:this.queryParams.wccsid,
        coolerLabel:this.queryParams.coolerLabel
      }
      console.log(params,'params');
       if(this.type==='store'){
        params.execTypeList=this.queryParams.execTypeList||'01,03,12,91,92,02,93'
        }else{
        params.execTypeList=this.queryParams.execTypeList||'01,03,12,91,92,02,93,04,05,21,22,23'
        }
      // if (this.type == "lost" || this.type == "scrap") {
      //   params.lostYear = this.queryParams.lostYear;
      //   params.lostMonth = this.queryParams.lostMonth;
      // }
      const { data } = await orderApi.queryCoolerList(params);
      if (data.resultCode == "0") {
        this.orderList = data.resultData.lostCoolerPagedList.rows;
        this.checkedList = this.orderList.map(item => {
          return {
            coolerAssetCode: item.coolerAsset.coolerAssetCode
          };
        });
        this.total = data.resultData.lostCoolerPagedList.pageProps.totalCounts;
      }
    },

    //查询审批中冰柜列表
    async queryApproveCoolerList() {
      let params = {
        pocName: this.queryParams.pocName,
        abiPocId: this.queryParams.abiPocId,
        wholesalerName: this.queryParams.wholesalerName,
        coolerAssetCode: this.queryParams.coolerAssetCode,
        coolerItemNo: this.queryParams.coolerItemNo,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        waitApprove: this.queryParams.waitApprove,
        wccsid:this.queryParams.wccsid,
        execTypeList:this.queryParams.execTypeList,
        coolerLabel:this.queryParams.coolerLabel
      };
      const { data } = await orderApi.queryCoolerList(params);
      if (data.resultCode == "0") {
        this.orderList = data.resultData.lostCoolerPagedList.rows;
        this.checkedList = this.orderList.map(item => {
          return {
            coolerAssetCode: item.coolerAsset.coolerAssetCode
          };
        });
        this.total = data.resultData.lostCoolerPagedList.pageProps.totalCounts;
      }
    },

    //复选框状态改变
    infoCheck(coolerItem) {
      //console.log(coolerItem)
      this.checkedList.forEach((item, index) => {
        //找到数组中的item项
        if (item.coolerAssetCode == coolerItem.coolerAssetCode) {
          this.checkedList[index] = coolerItem;
        }
      });

      let buttonClick = true;
      if (coolerItem.checked) {
        //新增选中
        this.registerButton = false; //按钮可点击
      } else {
        //遍历查看是否有已选中的项
        this.checkedList.forEach((item, index) => {
          if (this.checkedList[index].checked) {
            buttonClick = false; //如果有不禁用
          }
        });
        this.registerButton = buttonClick; //按钮禁用
      }
    },

    // 批量登记丢失冰柜
    async registerCoolerLostList(params) {
      const { data } = await orderApi.registerCoolerLostList(params);
      if (data.resultCode === "0") {
        this.showDialog = false;
        this.registerSucess = true; //登记成功弹窗
        this.queryCoolerList(); //重新更新列表
      }
    },

    // 批量登记报废冰柜
    async registerCoolerScrapList(params) {
      const { data } = await orderApi.registerCoolerScrapList(params);
      if (data.resultCode === "0") {
        this.showDialog = false;
        this.registerSucess = true; //登记成功弹窗
        this.queryCoolerList(); //重新更新列表
      }
    },

    //页数发生改变
    handleCurrentChange(val) {
      this.queryParams.page = val;

      if (this.type == "approve") {
        this.queryApproveCoolerList();
      } else {
        this.queryCoolerList();
      }
    },

    // 条件搜索
    search() {
      this.queryParams.page = 1;
      if (this.type == "approve") {
        this.queryApproveCoolerList();
      } else {
        this.queryCoolerList();
      }
    },

    //登记丢失
    registerLostCooler() {
      if (this.registerButton) {
        return;
      }
      this.registerType = "lost";
      this.applyReason = ""; //清空缓存
      this.showDialog = true;
    },

    //登记报废
    registerScrapCooler() {
      if (this.registerButton) {
        return;
      }
      this.registerType = "scrap";
      this.applyReason = ""; //清空缓存
      this.showDialog = true;
    },

    //确认登记
    confirmRegister() {
      let list = [];
      this.checkedList.forEach(item => {
        if (item.checked) {
          if (item.pocId) {
            list.push({
              coolerAssetCode: item.coolerAssetCode,
              pocId: item.pocId,
              applyReason: this.applyReason
            });
          } else {
            list.push({
              coolerAssetCode: item.coolerAssetCode,
              wholesalerId: item.wholesalerId,
              warehouseId: item.warehouseId,
              applyReason: this.applyReason
            });
          }
        }
      });
      //重新渲染列表
      if (this.registerType == "lost") {
        this.registerCoolerLostList(list);
      } else if (this.registerType == "scrap") {
        this.registerCoolerScrapList(list);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
 
.center-flex {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .dialog-text{
    line-height: 40px;
    display: flex;
    
  }
  
}
.dialog-data{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i{
    margin-left: 25px;
  }
  .dialog-text{
    font-size: 20px;
   
  }
}
.pagination .el-pagination {
  text-align: center;
}
.common {
  user-select: none;
}
.disable {
  background-color: gray;
  color: white;
  width: 80px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}
.normal {
  color: white;
  background-color: $base-red;
  width: 80px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.margin-top-15 {
  margin-top: 15px;
}

.item-input {
  margin-bottom: 15px;
  /* width: 200px;trade-order-list
  height: 36px;
  margin: 0 20px 20px 0; */
}
.el-select {
  width: 150px;
  height: 36px;
  margin: 0 15px 10px 0;
}

.trade-order-list {
  width: 100%;
  height: auto;
  padding-left: 60px;
  margin-top: 20px;
  box-sizing: border-box;
  .trade-order-item {
    width: 100%;
    min-height: 150px;
    margin: 15px 0;
    // padding: 15px 25px;
    border-radius: 10px;
    background-color: $base-white;
    box-sizing: border-box;
  }
  .no-data {
    text-align: center;
  }
}

.search-top-row {
  margin-left: 60px;
}
</style>
